<template>
    <div>
        <vx-card title="Violation" subtitle="Lists of Violations"  class="no-scroll-content" >
        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewViolation()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeViolation">
                    <template slot="thead">
                        <vs-th>Violation</vs-th>
                        <vs-th>Action Taken</vs-th>
                        <vs-th>Date Of Violation</vs-th>
                        <vs-th>isServed?</vs-th>
                        <vs-th>Date Served</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].violationId">
                                {{ violationName(data[indextr].violationId).violationName }}
                            </vs-td>
                            <vs-td :data="data[indextr].violationActionId">
                                {{violationActionName(data[indextr].violationActionId).violationActionName}}
                            </vs-td>
                            <vs-td :data="data[indextr].dateViolation">
                                {{data[indextr].dateViolation | fulldate}}
                            </vs-td>
                            
                            <vs-td :data="data[indextr].isServed">
                                <vs-checkbox v-model="data[indextr].isServed" class="pointer-events-none" />
                            </vs-td>
                            <vs-td :data="data[indextr].dateServed">
                                {{data[indextr].dateServed | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{data[indextr].remarks}}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD BANK INFORMATION -->
            <vs-prompt
                class="email-compose"
                title="Violation"
                accept-text= "Submit"
                @accept="onAddViolation"
                :is-valid="validForm"
                :active.sync="activePromptNewViolation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Violation</span><span style="color:red">*</span>
                        <v-select name="violation-name" v-model="violation" label="violationName" :options="getAllViolationLookup" placeholder="Select Item"/>

                    </div>
                </div>
              
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2">
                        <span  class="text-sm">Action Taken</span><span style="color:red">*</span>
                        <v-select  v-model="violationAction" label="violationActionName" :options="getAllViolationActionLookup" placeholder="Select Item"/>

                    </div>
                    
                </div>
                <div class="vs-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-checkbox   v-model="isServed">Is Violation Served?</vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Served</span><span v-if="isServed" style="color:red">*</span>
                        <datepicker  class="w-full" v-model="dateServed" placeholder="Select Date" :disabled="!isServed"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">Date of Violation</span><span style="color:red">*</span>
                        <datepicker class="w-full"  v-model="dateViolation" placeholder="Select Date"/>

                    </div>
                </div>
                
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span  class="text-sm">Remarks</span>
                        <vs-input class="w-full"  v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>
            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT BANK INFORMATION -->
            <vs-prompt
                class="email-compose"
                title="Violation"
                accept-text= "Submit"
                @accept="onEditViolation"
                :is-valid="validForm"
                :active.sync="activePromptEditViolation">
                <vx-card title="Fill-out the following information">


               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Violation</span><span style="color:red">*</span>
                        <v-select name="violation-name" v-model="violation" label="violationName" :options="getAllViolationLookup" placeholder="Select Item"/>

                    </div>
                </div>
              
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2">
                        <span  class="text-sm">Action Taken</span><span style="color:red">*</span>
                        <v-select  v-model="violationAction" label="violationActionName" :options="getAllViolationActionLookup" placeholder="Select Item"/>

                    </div>
                    
                </div>
                <div class="vs-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-checkbox   v-model="isServed">Is Violation Served?</vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Served</span><span v-if="isServed" style="color:red">*</span>
                        <datepicker  class="w-full" v-model="dateServed" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">Date of Violation</span><span style="color:red">*</span>
                        <datepicker class="w-full"  v-model="dateViolation" placeholder="Select Date"/>

                    </div>
                </div>
                
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span  class="text-sm">Remarks</span>
                        <vs-input class="w-full"  v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>
            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            violation           : [],
            violationAction     : [],
            dateServed          : null,
            dateViolation       : null,
            isServed            : false,
            remarks             : '',
            userId              : null,

            uid                 : null,
            activePromptNewViolation    : false,
            activePromptEditViolation    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.$vs.loading()
            this.$store.dispatch('lookup/getAllViolationLookup', { userId : null})
            this.$store.dispatch('lookup/getAllViolationActionLookup')
            this.$store.dispatch('lookup/getAllPeriodLookup')
                .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.uid = this.$route.params.id
            this.employeeViolation = this.uid
            
    },
    computed: {
        employeeViolation: {
           
           get() { return this.$store.state.hrms.employeeViolation },
           set(value) { this.$store.dispatch('hrms/getAllViolation',  value )}
            
        },
        validForm(){
            return this.violation.violationId != null && this.violationAction.violationActionId != null && 
                this.dateViolation !=null && (this.isServed ? this.dateServed != null : this.dateServed == null )
        },
        getAllViolationLookup() {
            return this.$store.state.lookup.getAllViolationLookup
        },
        getAllViolationActionLookup(){ 
            return this.$store.state.lookup.getAllViolationActionLookup
        },
        
        violationName() {
            return (id) => this.$store.getters['lookup/violationLookup'](id)
        },
        violationActionName() {
            return (id) => this.$store.getters['lookup/violationActionLookup'](id)
        },
    },
    watch: {
        isServed() {
                this.dateServed = this.isServed ? this.dateServed : null
        }
    },
    methods: {
        promptAddNewViolation() {
            this.activePromptNewViolation = true
        },
        onAddViolation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                    this.$vs.loading()

                    const data = {
                        violationId: this.violation.violationId,
                        violationActionId: this.violationAction.violationActionId,
                        dateServed: this.isServed ? this.dateServed : null,
                        dateViolation: this.dateViolation,
                        isServed: this.isServed,
                        remarks:this.remarks,
                        userId: this.uid,
                        currentUserId           : this.$store.state.AppActiveUser.uid
                    }
                    //console.log("BANK")
                    //console.log(data)
                    this.$store.dispatch('hrms/AddViolation', data)
                    .then((response) =>{
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Violation Saved',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                    // form have errors
                    this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                }
                })
        },
        onEditViolation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id              : this.id,
                    violationId          : this.violation.violationId,
                    violationActionId        : this.violationAction.violationActionId,
                    dateServed        : this.isServed ? this.dateServed : null,
                    dateViolation   : this.dateViolation,
                    isServed          : this.isServed,
                    remarks          : this.remarks,
                    userId          : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateViolation', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Violation Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeViolation'](Id)
            this.id = e.id,
            this.violation = this.violationName(e.violationId),
            this.violationAction = this.violationActionName(e.violationActionId),
            this.dateServed = e.dateServed,
            this.dateViolation = e.dateViolation,
            this.isServed = e.isServed,
            this.remarks = e.remarks,
            this.userId = e.userId

            this.activePromptEditViolation = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteViolation', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeViolation = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Violation Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>